export const originalSourceRegistry = {
  artifacts: [
    {
      name: 'SQI_Procurement_Execution_Pack.zip',
      version: 2,
      bytes: 14328341,
      sha256: '9273acb0838e26a3dfc7ab1b2f68fbb9e7fbc80ab898377466921547b4bec508',
      status: 'preserved_reference_baseline',
      importEligible: false,
      libraryVerified: false,
    },
    {
      name: 'SQI_Factory_Purchasing_Audit_2026-10-03.pdf',
      version: 0,
      bytes: 67466,
      sha256: 'f94284648d1e591d33256c7b031090b37be73bf8a00e4fd8338e4e9265e08dbf',
      status: 'preserved_reference_baseline',
      importEligible: false,
      libraryVerified: false,
    },
    {
      name: 'SQI_Master_Raw_Material_Procurement.xlsx',
      version: 2,
      bytes: 607221,
      sha256: '0757e5bdbc2280167f816eb779a968875b276dd3d7e6c124f346a39eefbc8b0b',
      status: 'preserved_reference_baseline',
      importEligible: false,
      libraryVerified: false,
    },
    {
      name: 'SQI_Private_Prototype_2026-10-03_Overnight_v2_Source_Evidence.zip',
      version: 'v2',
      bytes: 29640940,
      sha256: '842e201ac09f2c28a672dbcdf347ffe67daca67c0d26ca2519d2eeef9e144408',
      status: 'preserved_reference_baseline',
      importEligible: false,
      libraryVerified: false,
    },
  ],
  unavailable: ['Procurement master v3', 'Execution ZIP v3', 'OEM report/workbook v1'],
  adapter: {
    name: '0007-master-data-ownership-and-change-control.md',
    sha256: '1c34e62c2538b1574a62c10f24287bc1fac7ad961a1ddeab22145b5d1fd595f0',
    status: 'read_only_ownership_provenance',
    liveDataVerified: false,
  },
  policy: 'reference-only; only explicit synthetic normalized fixtures may be adopted locally',
} as const;
